export default __webpack_public_path__ + "0fa720690e8422b19bb2a337645a96fd.png";